import { render, staticRenderFns } from "./CrearAvisoView.vue?vue&type=template&id=fc3f218a&"
import script from "./CrearAvisoView.vue?vue&type=script&lang=js&"
export * from "./CrearAvisoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports